// ant-design-vue 的dialog

import Vue from 'vue';
import { LxtDialog } from '@lxt/ant-component-vue';

const DialogConstructor = Vue.extend(LxtDialog);

const instances = [];

/**
 *
 * @param options
 * {
 *      attrs: antd modal 默认attrs
 *      listeners: antd modal 默认监听
 *      store: dialog组件所需的store数据
 *      router: dialog组件所需的路由
 *      content: 自定义content组件 Object
 *      {
 *          attrs: 入参
 *          listeners: 监听
 *      }
 *      footer: 自定义footer组件 Object
 *      {
 *          attrs: 入参
 *          listeners: 监听
 *      }
 * }
 * @returns {*}
 * @constructor
 */
const Dialog1 = function (options = {}) {
    const id = `ap_dialog_${Math.random().toString(32)}`;

    const { store, router } = options;
    const opt = {
        store,
        router,
        data: {
            ...options,
            closeDialog: () => {
                Dialog1.close();
            },
        },
    };
    delete opt.data.store;
    delete opt.data.router;

    const instance = new DialogConstructor(opt);
    // 合并相关数据
    instance.id = id;
    instance.$mount();

    instance.visible = true;
    instances.push(instance);

    return instance;
};

Dialog1.close = () => {
    const instance = instances.pop();

    // document.body.removeChild(instance.$el);
    instance.$destroy();
};


export default Dialog1;
